<div class="bg-th-yellow mt-0 container-fluid">
  <div class=" d-flex justify-content-between align-content-center h-35">
    <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>
    <span class="my-auto f16 fw-bold me-2">حوزه خدمت</span>
  </div>
</div>

<section class="container dirI">
  <div class="d-flex justify-content-between m-4">
    <div class="col-md-3 col-5">
      <div class="input-group mb-1">
        <input type="text" class="form-control rounded" placeholder="جستجو..." (keyup)="searchbox($event.target.value)">
        <button class="btn btn-primary rounded" type="submit">
          <i class="fa fa-search"></i>
        </button>
      </div>
    </div>
    <div><button class="btn btn-outline-primary" data-bs-toggle="modal" (click)="editMode=false; addSa()"
        data-bs-target="#editSA">افزودن
        &nbsp;<i class="fa fa-plus-circle"></i></button></div>
  </div>

  <div class="table-responsive " style="max-height: 86vh;">

    <table class="table table-striped" *ngIf="serviceAreas?.length > 0">

      <thead class="position-sticky top-0 bg-white text-center">

        <tr class="text-center">

          <th scope="col" class="position-sticky text-center">عملیات</th>

          <th scope="col" class="position-sticky pointer" (click)="sortBy(0)">حوزه خدمت 
            
            <i class="fa fa-sort-amount-asc pointer"></i>&nbsp;
          
          </th>

          <th scope="col" class="position-sticky pointer" (click)="sortBy(1)">شهر 
            
            <i class="fa fa-sort-amount-asc pointer"></i>&nbsp;
          
          </th>

        </tr>

      </thead>

      <tbody>

        <tr [id]="'row'+item.iMobileDomain" class="pointer text-center" *ngFor="let item of serviceAreas;let i=index">

          <th class="">

              <i class="btn btn-outline-success fa fa-edit mx-2" 
              
                (click)="editMode=true; 
                
                openEditModal(item)"

                data-bs-toggle="modal" 
                
                data-bs-target="#editSA">
              
              </i>

              <i class="btn btn-outline-danger fa fa-trash" (click)="DeleteSA(item)"></i>

            </th>

          <th class="text-dark f14">{{item.strComment}}</th>

          <th class="text-dark f14">{{item.Expr1}}</th>


        </tr>

      </tbody>

    </table>

    <div *ngIf="serviceAreas?.length == 0" class="d-flex justify-content-center align-items-center">

      <strong>موردی یافت نشد...</strong>

    </div>

  </div>

</section>

<!-- Edit and Add Modal -->
<div class="modal fade" id="editSA" tabindex="-1" aria-labelledby="AddSA" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between dirI">
        <h5 class="modal-title" id="addUserLabel">{{editMode? 'ویرایش حوزه خدمت': 'افزودن حوزه خدمت جدید'}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">

        <div class="container-fluid">

          <div class="row">

            <form [formGroup]="SAInputs" class="dirI">

              <div class="form-group row mb-2">
                <label for="hoze" class="col-sm-2 col-form-label">حوزه خدمت:</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" name="1" id="1" formControlName="strComment">
                </div>
              </div>

              <div class="form-group row mb-2">

                <label for="hoze" class="col-sm-2 col-form-label">شهر:</label>

                <div class="col-sm-10">

                  <input type="text" name="selectedCity" 
                  
                  autocomplete="off" formControlName="Expr1"

                  (focus)="filteredCity = list_City"
  
                  (blur)="hideCity_Option()"
                  
                  class="form-control" placeholder="نام شهر را جستجو کنید" 
                  
                  [(ngModel)]="searchT_City" (input)="filterCity()" />
            
                  <ul class="list-group" style="max-height: 200px;overflow: auto;">
          
                      <li class="list-group-item pointer" *ngFor="let item of filteredCity" 
                      
                          [@fadeAnimation] (click)="selectedCity(item)">
                          
                          {{ item.strCityName }}
                      
                      </li>
                      
                  </ul>
                </div>
                
              </div>
              
              <div class="form-group row mb-2">
                <label for="timeh" class="col-sm-2 col-form-label">آخرین مهلت ثبت درخواست سفر: </label>
                <div class="d-flex col-sm-4 gap-1 align-items-center">
                  <div class="input-group clockpicker">
                    <input type="text" class="form-control bg-light" name="2" formControlName="strTripRequestEndTime"
                      id="Stime" readonly>
                    <span class="input-group-addon ">
                      <span class="glyphicon glyphicon-time"></span>
                    </span>
                  </div>
                </div>
                <label for="radious" class="col-sm-1 col-form-label" style="margin-right: auto;">شعاع:</label>
                <div class="col-sm-4">
                  <input type="number" class="form-control" id="3" name="3" formControlName="iRadious">
                </div>
              </div>

              <div class="form-group row mb-2">
                <label for="parkRed" class="col-sm-2 col-form-label">شعاع پارکینگ:</label>
                <div class="col-sm-4">
                  <input type="number" class="form-control" id="4" name="4" formControlName="iParkingRadious">
                </div>
                <label for="cityRad" class="col-sm-2 col-form-label text-end">شعاع شهر:</label>
                <div class="col-sm-4">
                  <input type="number" class="form-control" id="5" name="5" formControlName="iMissionRadious">
                </div>
              </div>

              <div class="form-group row mb-2 bg-th-yellow rounded">
                <label for="parkRed" class="col-sm-2 col-form-label">عرض اداره</label>
                <div class="d-flex align-items-center col-sm-4">
                  <input type="number" class="form-control text-center" id="6" name="6" formControlName="fLat">
                </div>
                <label for="cityRad" class="col-sm-2 col-form-label text-end">طول اداره:</label>
                <div class="d-flex align-items-center col-sm-4">
                  <input type="number" class="form-control text-center" id="7" name="7" formControlName="fLon">
                  <i (click)="newOpenMap(0)" class="fa fa-map-marker text-primary pointer"
                    style="font-size: 25px; padding-right: 7px;"></i>
                </div>
              </div>

              <div class="form-group row mb-2 bg-th-yellow rounded">
                <label for="parkRed" class="col-sm-2 col-form-label">عرض شهر</label>
                <div class="d-flex align-items-center col-sm-4">
                  <input type="number" class="form-control text-center" id="8" name="8" formControlName="fCityLat">
                </div>
                <label for="cityRad" class="col-sm-2 col-form-label text-end">طول شهر:</label>
                <div class="d-flex align-items-center col-sm-4">
                  <input type="number" class="form-control text-center" id="9" name="9" formControlName="fCityLon">
                  <i (click)="newOpenMap(1)" class="fa fa-map-marker text-primary pointer"
                    style="font-size: 25px; padding-right: 7px;"></i>
                </div>
              </div>

              <div class="form-group row mb-2">
                <label for="payCo" class="col-sm-2 col-form-label">کد درگاه پرداخت:</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="10" name="10" formControlName="strTerminalID">
                </div>
              </div>

              <div class="form-group row mb-2">
                <label for="bank" class="col-sm-2 col-form-label">نام بانک درگاه:</label>
                <div class="d-flex align-items-center col-sm-4">
                  <input type="text" class="form-control" id="11" name="11" formControlName="strBankName">
                </div>
                <label for="commission" class="col-sm-2 col-form-label text-end">درصد کمیسیون:</label>
                <div class="d-flex align-items-center col-sm-4">
                  <input min="0" max="100" type="number" class="form-control text-center" id="12" name="12"
                    formControlName="tiCommission">
                </div>
              </div>

              <div class="form-group row mb-2">
                <label for="med" class="col-sm-2 col-form-label">فایل مدیا:</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="13" placeholder="آدرس URL..." name="13"
                    formControlName="strSchoolBusMedia">
                </div>
              </div>

            </form>

          </div>

        </div>

      </div>

      <div class="modal-footer dirI">

        <button type="button" class="btn btn-success" (click)="EditSA()">{{editMode? 'ویرایش': 'ثبت'}}
          
          <i class="fa fa-check-square-o"></i>
        
        </button>

        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">لغو <i class="fa fa-close"></i></button>

      </div>

    </div>

  </div>

</div>


<div class="modal fade" id="maplat" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content p-1">
      <div class="modal-header dirI">
        <h5 class="modal-title">ثبت موقعیت</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div id="map" class="position-sticky w-100 " style="height: 500px;">
        <div [formGroup]="latoLong" class="d-flex justify-content-around position-absolute dirI bg-th-yellow w-100 p-1"
          style="z-index: 1000; margin-bottom: 10px;">
          <div class="mx-1">
            <label for="lat">عرض جغرافیایی: </label>
            <input readonly id="lat" type="text" formControlName="latIn" class="mx-2" #lat>
          </div>
          <div class="mx-1">
            <label for="lon">طول جغرافیایی: </label>
            <input readonly id="lon" type="text" formControlName="longIn" class="mx-2">
          </div>
        </div>
        <div class="position-absolute" id="map_tooltip" data-bs-html="true">
        </div>
      </div>
      <button (click)="confirmLatol(mapEditType)" *ngIf="lat.value != ''" data-bs-dismiss="modal"
        class="btn btn-success">تایید <i class="fa fa-check"></i></button>
    </div>
  </div>
</div>